import {
  Additional,
  Danger,
  Neutral,
  Primary,
  Success,
  SystemColors,
  Warning,
} from 'themes/types';

const WARNING: Warning = {
  warning_500: '#DA6D00',
  warning_300: '#FF9800',
  warning_200: '#FFD500',
};

const DANGER: Danger = {
  danger_500: '#B20101',
  danger_300: '#E51C23',
};

const SUCCESS: Success = {
  success_500: '#0E5600',
  success_300: '#74A611',
  success_200: '#BEE428',
  success_100: '#E9FFE5',
};

const NEUTRAL: Neutral = {
  neutral_900: '#000000',
  neutral_700: '#1E1E1E',
  neutral_500: '#464646',
  neutral_300: '#C4C4C4',
  neutral_200: '#EDEDED',
  neutral_100: '#FFFFFF',
};

const PRIMARY: Primary = {
  primary_500: '#273EB2',
  primary_300: '#3859FF',
  primary_200: '#E8ECFF',
};

const ADDITIONAL: Additional = {
  yellow: '#FFFABB',
  pink: '#ED777F',
  purple: '#717DD7',
};

export const SYSTEM_COLORS: SystemColors = {
  ...WARNING,
  ...DANGER,
  ...SUCCESS,
  ...NEUTRAL,
  ...PRIMARY,
  ...ADDITIONAL,
};
